import { render, staticRenderFns } from "./tBlocks.vue?vue&type=template&id=241caf51&scoped=true"
import script from "./tBlocks.vue?vue&type=script&lang=js"
export * from "./tBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241caf51",
  null
  
)

export default component.exports